import {useEffect} from 'react';
import {useAppDispatch} from '../../../app/hooks/useAppDispatch';
import {blockUI, unblockUI} from '../coreSlice';

export const useBlockUI = (condition: boolean) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (condition) {
      dispatch(blockUI());
      return () => {
        dispatch(unblockUI());
      };
    }
  }, [condition, dispatch]);
};
